var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoading
    ? _c(
        "div",
        { staticClass: "go-widget go-widget-side go-widget-reference" },
        [
          _c("div", { staticClass: "go-widget-header" }, [
            _vm.headingSelected
              ? _c(
                  "div",
                  { staticClass: "go-widget-filter go-filter-selected" },
                  [
                    _c("ul", { staticClass: "go-filter-selected-list" }, [
                      _c("li", { staticClass: "go-filter-selected-item" }, [
                        _c("em", { staticClass: "go-text" }, [
                          _vm._v(_vm._s(_vm.headingSelected)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "go-btn-cancel",
                            on: { click: _vm.clearHeading },
                          },
                          [_c("i", { staticClass: "go-icon-18 go-icon-close" })]
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "go-widget-title" }, [
              _vm._v("\n      " + _vm._s(_vm.$t("report.reportReference"))),
              _c("small", { staticClass: "go-count" }, [
                _vm._v(_vm._s(_vm.referentItems.length)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "go-widget-body" }, [
            _c(
              "div",
              { staticClass: "go-list-wrap" },
              [
                _c(
                  "vue-custom-scrollbar",
                  {
                    staticClass: "go-list-inner",
                    attrs: { settings: _vm.scrollSettings },
                  },
                  [
                    _c(
                      "ul",
                      {
                        staticClass:
                          "go-card-sub-list go-card-reference2 go-view-list",
                      },
                      _vm._l(_vm.referentItems, function (document, index) {
                        return _c("reference-card-component", {
                          key:
                            "report_reference_card_" +
                            index +
                            "_" +
                            Math.floor(Math.random() * 10000),
                          attrs: {
                            "form-model": document,
                            "style-for":
                              _vm.REFERENCE_STYLE_FOR.REPORT_REFERENCE,
                            "index-item": index,
                          },
                        })
                      }),
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "go-widget-footer" }, [
            _vm.showEditReference
              ? _c("div", { staticClass: "go-btn-area" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-default",
                      attrs: {
                        disabled:
                          !_vm.getSelectedResource ||
                          !_vm.getSelectedResource.owner_user_key ||
                          _vm.getSelectedResource.owner_user_key ===
                            undefined ||
                          !_vm.userKey ||
                          _vm.userKey === "" ||
                          _vm.userKey !==
                            _vm.getSelectedResource.owner_user_key,
                        type: "button",
                        "data-toggle": "modal",
                        "data-target": "#go-add-reference",
                      },
                      on: { click: _vm.handleOpenModel },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("report.edit")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "go-popover-wrap go-popover-open",
                      attrs: {
                        "data-toggle": "popover",
                        "data-container": "body",
                        "data-content":
                          "<p>편집한 래퍼런스로 리포트 재생성을 원하시면 [리포트 재생성] 버튼을 클릭하세요.</p><a class='close' href='#''><i class='go-icon-18 go-icon-close-g'></i></a>",
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn go-btn-primary",
                          attrs: {
                            disabled:
                              !_vm.getSelectedResource ||
                              !_vm.getSelectedResource.owner_user_key ||
                              _vm.getSelectedResource.owner_user_key ===
                                undefined ||
                              !_vm.userKey ||
                              _vm.userKey === "" ||
                              _vm.userKey !==
                                _vm.getSelectedResource.owner_user_key ||
                              !_vm.isAllowOpenPopup,
                            type: "button",
                            "data-toggle": "modal",
                            "data-target": "#go-setting-report",
                          },
                          on: {
                            click:
                              _vm.handleOpenPopupReportSettingReportTypeModal,
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("report.regenerateReport")) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }